import React from 'react';
import { useDispatch } from 'react-redux';
import { SBER_POPUP_KEY } from "../constants/payment";
import { sberActions } from "../store/features/sberpay/actions";
export var useSberResultState = function useSberResultState() {
  var dispatch = useDispatch();
  React.useEffect(function () {
    var query = new URLSearchParams(window.location.search);
    if (query.has(SBER_POPUP_KEY)) {
      dispatch(sberActions.setFrom3DS(true));
      dispatch(sberActions.setPaymentStatus(query.get(SBER_POPUP_KEY)));
    }
  }, []);
};